import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { setShapeDescriptorAttribute } from '../../store/studio';
import { StudioTextShapeDescriptor } from '../../store/studio/text/studio-text-shape';
import { FontService } from '../../control-panel/canvas-control-panel/text/font.service';

@Component({
  selector: 'nw-text-style-edits',
  templateUrl: './text-style-edits.component.html',
  styleUrls: ['./text-style-edits.component.scss'],
})
export class TextStyleEditsComponent {
  @Input() selectedShape: { id: string; descriptor: StudioTextShapeDescriptor };
  @Input() selectedCellColor = '#ffffff';
  @Output() closed = new EventEmitter<void>();

  constructor(
    private store: Store,
    private fontService: FontService,
  ) {}

  onFontFamilySelected(fontFamily: string) {
    this.store.dispatch(setShapeDescriptorAttribute({ key: 'fontFamily', value: fontFamily }));
  }

  onColorSelected(color: string) {
    this.store.dispatch(setShapeDescriptorAttribute({ key: 'fill', value: color }));
  }

  toggleTextAlign(currentAlign: string | undefined) {
    const alignments = ['left', 'center', 'right'];
    const currentIndex = alignments.indexOf(currentAlign || 'center');
    const nextAlign = alignments[(currentIndex + 1) % alignments.length];
    this.store.dispatch(setShapeDescriptorAttribute({ key: 'align', value: nextAlign }));
  }

  toggleFontWeight(currentWeight: number | undefined) {
    const family = this.selectedShape?.descriptor?.fontFamily;
    const weights = (family && this.fontService.availableWeights[family]) || this.fontService.ALL_WEIGHTS;
    const current = currentWeight || 500;
    const currentIndex = weights.indexOf(current);
    const nextWeight = currentIndex === -1 || currentIndex === weights.length - 1
      ? weights[0]
      : weights[currentIndex + 1];
    this.store.dispatch(setShapeDescriptorAttribute({ key: 'fontWeight', value: nextWeight }));
  }
}
